import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');

const propTypes = {
    id: PropTypes.string,
    selectedRoleToken: PropTypes.string,
    className: PropTypes.string,
    onRoleChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

const defaultProps = {
    id: 'project-role-select',
    roleToken: null,
    className: '',
    disabled: false,
};

function ProjectRoleDropdown(props) {
    const roleOptions = [
        {
            value: Globals.users.roles.PROJECT_MANAGER,
            content: StringUtil.getStringForRoleToken(Globals.users.roles.PROJECT_MANAGER)
        },
        {
            value: Globals.users.roles.AUTHOR,
            content: StringUtil.getStringForRoleToken(Globals.users.roles.AUTHOR)
        },
        {
            value: Globals.users.roles.REVIEWER,
            content: StringUtil.getStringForRoleToken(Globals.users.roles.REVIEWER)
        }
    ];

    let triggerContent = "Select a role...";

    const roleMenuItems = roleOptions.map((role) => {
        let itemClass = 'AriaMenuButton-menuItem';
        if(props.selectedRoleToken === role.value) {
            itemClass += ' is-selected';
            triggerContent = role.content;
        }

        return (
            <li className='AriaMenuButton-menuItemWrapper' key={role.value}>
                <MenuItem
                className={itemClass}
                value={role.value}
                text={role.content}>
                    {role.content}
                </MenuItem>
            </li>
        );
    });

    return (
        <Wrapper
            id={props.id}
            className={`AriaMenuButton ${props.className}`}
            onSelection={props.onRoleChange}
        >
            <Button className='AriaMenuButton-trigger' disabled={props.disabled}>
                {triggerContent}
            </Button>
            <Menu>
                <ul className='AriaMenuButton-menu'>
                    {roleMenuItems}
                </ul>
            </Menu>
        </Wrapper>
    );
}

ProjectRoleDropdown.propTypes = propTypes;
ProjectRoleDropdown.defaultProps = defaultProps;

export default ProjectRoleDropdown;